import React, { ReactElement, ReactNode, useCallback, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import LayoutContext from '../contexts/LayoutContext';
import { BreadcrumbItem } from '../models/layout/BreadcrumbItem';
import { LayoutContextState, LayoutContextValue } from '../models/layout/LayoutContext';
import { MenuGroupKey } from '../models/layout/MenuBarItemModel';

interface LayoutStoreProps {
    children?: ReactNode;
}

const LayoutStore = ({ children }: LayoutStoreProps): ReactElement => {
    // La ruta se toma del router y no de window.location: el router la entrega
    // decodificada ("/componentes/5GEB25/descripcion/MOTOR DE TRACCION").
    const { pathname } = useLocation();
    const pathnameRef = useRef(pathname);
    pathnameRef.current = pathname;

    const [layoutContextState, setLayoutContextState] = useState<LayoutContextState>({
        headerTitle: 'Título de página',
        breadcrumbItems: [
            /*
            {
                label: 'Inicio',
                href: '/',
                active: false,
            },
            {
                label: 'Ejemplo',
                active: true,
            },
            */
        ],
        breadcrumbPath: '',
        isMenuBarActive: false,
        menuSolicitado: null,
    });

    const setHeaderTitle = useCallback(
        (title: string): void =>
            setLayoutContextState((prevState) => ({
                ...prevState,
                headerTitle: title,
            })),
        [],
    );

    const setBreadcrumbItems = useCallback(
        (items: Array<BreadcrumbItem>): void => 
            setLayoutContextState((prevState) => ({
                ...prevState,
                breadcrumbItems: items,
                breadcrumbPath: pathnameRef.current,
            })),
        [],
    );

    const toggleMenuBar = (menuBarState?: boolean): void => 
        setLayoutContextState((prevState) => {
            if (menuBarState !== undefined) {
                return {
                    ...prevState,
                    isMenuBarActive: menuBarState,
                }
            } else {
                return {
                    ...prevState,
                    isMenuBarActive: !prevState.isMenuBarActive,
                }
            }
        });
    

    const abrirMenu = useCallback(
        (group: MenuGroupKey, seccion?: string): void =>
            setLayoutContextState((prevState) => ({
                ...prevState,
                isMenuBarActive: true,
                menuSolicitado: { group, seccion, n: (prevState.menuSolicitado?.n || 0) + 1 },
            })),
        [],
    );

    const LayoutContextValue: LayoutContextValue = {
        ...layoutContextState,
        setHeaderTitle,
        setBreadcrumbItems,
        toggleMenuBar,
        abrirMenu,
    };

    return <LayoutContext.Provider value={LayoutContextValue}>{children}</LayoutContext.Provider>;
};

export default LayoutStore;